import { useEffect } from "react";
import { usePages } from "../../context/pageContext";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingPage } from "../loading";

export default function LoadRedirect() {
  const { pages } = usePages();
  const navigate = useNavigate();
  const location = useLocation();
  const url = location?.state?.from;

  const pagePath: string[] = [];

  useEffect(() => {
    if (pages === undefined || pages === null) return;

    if (Array.isArray(pages) && pages.length === 0 && !url) {
      navigate("/welcome", { replace: true });
      return;
    }

    if (Array.isArray(pages) && pages.length === 0 && url) {
      return;
    }

    const findPages = (items: Dash[]): void | undefined => {
      for (const item of items) {
        if ("path" in item && typeof item.path === "string") {
          pagePath.push(item.path);
        }
        if ("subPages" in item && Array.isArray(item.subPages)) {
          findPages(item.subPages);
        }
      }
      return undefined;
    };

    findPages(pages);

    if (url && pagePath.includes(url)) {
      navigate(url);
    } else if (pagePath.length > 0) {
      navigate(pagePath[0]);
    } else if (!url) {
      navigate("/welcome", { replace: true });
    }
  }, [pages, url]);

  return <LoadingPage />;
}
